import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../msal/auth.service';
import { OfficeWebsiteService } from 'src/app/office-websites/services/office-website.service';
import { SearchUpdateConfirmationComponent } from '../search-update-confirmation/search-update-confirmation.component';
import { CommonService } from '../../services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-office-website-sub-menu',
  templateUrl: './office-website-sub-menu.component.html',
  styleUrls: ['./office-website-sub-menu.component.scss']
})

export class OfficeWebsiteSubMenuComponent implements OnInit {
  public url: string = '';
  submenu: boolean = false;
  @Output() closeSidebarHeader = new EventEmitter<any>();
  @ViewChild('changeMenuModal', {static: true})
  public changeMenuModal: SearchUpdateConfirmationComponent | any;
  public isMobileDevice = false;
  enableCoopCompSubMenu: boolean = false;
  menu: string = '';
  constructor(
    private officewebsiteService: OfficeWebsiteService,
    private router: Router,
    private authService: AuthService,
    private commonService: CommonService
  ) {
    this.enableCoopCompSubMenu = (environment.enableCoopCompSubMenu === 'true');
    this.authService.subscribeToUrl((url: any) => {
      this.url = url;
    })
  }

  ngOnInit(): void {
    this.officewebsiteService.updateSelectedMenu('officeSelectedMenu');
    this.isMobileDevice = this.commonService.isMobileDevice();
    if(sessionStorage.getItem('currentUrl'))
      {
        this.url = sessionStorage.getItem('currentUrl') as string;   
        if(!this.url.includes('portal/office-websites/office-website-') && this.url !== "/portal/office-websites")
            this.submenu = true;     
      }
  }

  /** return the selected menu */
  get selectedMenu(): string {
    return this.officewebsiteService.selectedMenu;
  }

  /**
   * check if the menu is selected or not
   * @param menuItem 
   * @return boolean
   */

  public isMenuSelected(menuItem: string): boolean {
    return this.selectedMenu === menuItem;
  }

  /**
   * update the selected menu
   * @param menuItem 
   */
  
  public selectMenu(menuItem: string): void {
    this.menu = menuItem;
    if(this.commonService.getFormUpdateStatus()) {
      this.changeMenuModal.showModal();
    } else {
      this.selectMenuConfirmation();
    } 
  }

  /** select Menu confirmation popup event */
  selectMenuConfirmation() {
    this.commonService.setFormUpdateStatus(false);
    this.officewebsiteService.updateSelectedMenu(this.menu);
    this.closeSidebarHeader.emit(true);
    sessionStorage.setItem('activeUrl', '/portal/office-websites/' + this.menu)
    this.router.navigate(['/portal/office-websites/' + this.menu])
  }

  /** office information submenu */
  toggleDisplay() {
    this.submenu = !this.submenu;
    if(!this.isMobileDevice && !sessionStorage.getItem('currentUrl')?.includes('/portal/office-websites/')){
      this.router.navigate(['/portal/office-websites/office-contact-info']);
    }    
  }
}
